.signet-pdf-pagination {
  .container {
    border: 1px solid var(--gray-200);
    border-radius: 5px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px;

    .label {
      white-space: nowrap;
    }

    .icon-container {
      display: flex;
      margin-left: 10px;

      .icon {
        color: var(--primary-main);
        line-height: 1 !important;
        cursor: pointer;
      }
    }
  }
}
